import React from 'react';
const MenuToggle = (props) => (
    <div className="menu-toggle-wrapper">
        <a onClick={props.toggle} className="menu-toggle">
            <span className="menu-icon-line-1 menu-icon-line"></span>
            <span className="menu-icon-line-2 menu-icon-line"></span>
            <span className="menu-icon-line-3 menu-icon-line"></span>
        </a>
    </div >
);

export default MenuToggle;


// WEBPACK FOOTER //
// ./src/components/Navigation/MenuToggle.js